<template>
  <div class="wlx-site-basic-wrapper">
    <el-tabs tab-position="top" style="height: auto" v-model="tabName" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="first">
        <siteInfo v-if="tabName=='first'"></siteInfo>
      </el-tab-pane>
      <el-tab-pane label="密码管理" name="second">
        <PassWordEdit v-if="tabName=='second'"></PassWordEdit>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { MU_UPATE_AUTH } from "store/index";
import siteInfo from "page/xSchool/siteManager/siteInfo.vue";
import PassWordEdit from "page/xSchool/manager/PassWordEdit.vue";
export default {
  data() {
    return {
      tabName: "first"
    };
  },
  components: {
    siteInfo,
    PassWordEdit
  },
  created() {
    
    var that = this;
    if (localStorage["userId"] !== undefined) {
      that.$store.dispatch(MU_UPATE_AUTH).then(rt => {});
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  computed: {}
};
</script>
<style lang="scss">
.wlx-site-basic-wrapper{
  .el-tabs__header {
        position: fixed;
        top: 60px;
        right: 0;
        height: 60px;
        width: calc(100% - 240px);
        z-index: 1000;
        background: #fff;
        text-align: right;
    }
    .el-tabs__item {
        width: 120px;
        text-align: center;
        height: 60px;
        line-height: 60px;
        font-size: 16px;
    }
    .el-tabs__content {
        margin: 80px 0 0 30px;
        background: #fff;
        .el-tab-pane {
            padding: 20px;
        }
    }
}
</style>
